import { Box, makeStyles } from "@material-ui/core";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import TopBar from "../../components/Common/TopBar";
import { useToken } from "../../utilities/hooks";
import DetailedQuery from "../../components/OrderExchangeStatistics/DetailedQuery/index";
import SummaryQuery from "../../components/OrderExchangeStatistics/SummaryQuery/index";
import UserQuery from "../../components/OrderExchangeStatistics/UserQuery/index";
import TimingQuery from "../../components/OrderExchangeStatistics/TimingQuery/index";
import _ from 'lodash';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.default,
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        margin: 0
    },
    appBarClasses: {
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
        padding: theme.spacing(1)
    },
    topBarButton: {
        marginLeft: theme.spacing(2),
        color: 'unset',
        '&:hover': {
            color: theme.palette.text.primary
        }
    },
    buttonGroupStyle: {
        textAlign: 'right',
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(2)
    },
}))

function OrderExchangeStatistics(props) {
    const dispatch = useDispatch();
    const classes = useStyles();
    const { t } = useTranslation('orderExchange');
    const [manageIndex, setManageIndex] = useState('summarySection');
    const tokenContents = useToken();
    const authorizedWarehouses = tokenContents.warehouse;
    const [isDataLoading, setIsDataLoading] = useState(false);

    const manageIndices = {
        summarySection: {
            id: 0,
            text: t('summary_query')
        },
        detailedSection: {
            id: 1,
            text: t('detailed_query')
        },
        timingSection: {
            id: 2,
            text: t('timing_query')
        },
        userSection: {
            id: 3,
            text: t('user_query')
        }
    };

    const handleManageIndex = (event) => {
        setManageIndex(event.target.value);
    }

    return (
        <Box className={classes.root}>
            <TopBar
                title={t('bbc_order_exchange')}
                buttonClasses={classes.topBarButton}
                appBarClasses={classes.appBarClasses}
                handleRadioChange={handleManageIndex}
                radios={manageIndices}
                radio={manageIndex}
            />
            <div hidden={manageIndex !== 'summarySection'}>
                <SummaryQuery />
            </div>

            <div hidden={manageIndex !== 'detailedSection'}>
                <DetailedQuery />
            </div>
            <div hidden={manageIndex !== 'timingSection'}>
                <TimingQuery />
            </div>
            <div hidden={manageIndex !== 'userSection'}>
                <UserQuery />
            </div>
        </Box>
    );
}

export default OrderExchangeStatistics;